// Программа передач: определение текущего дня и переключение
document.addEventListener('DOMContentLoaded', () => {
    const today = new Date().getDay();
    const todayIndex = today === 0 ? 6 : today - 1; // Вс=6, Пн=0

    const buttons = document.querySelectorAll('.hh-tv-schedule-week .hh-day-btn');

    // Подсветить сегодня при загрузке
    if (buttons[todayIndex]) {
        buttons[todayIndex].classList.add('active-day');
    }

    // Переключение active при клике
    buttons.forEach(btn => {
        btn.addEventListener('click', () => {
            buttons.forEach(b => b.classList.remove('active-day'));
            btn.classList.add('active-day');
        });
    });

    scrollToLiveProgram();
});

function scrollToLiveProgram() {
    const liveProgram = document.getElementById('live-program') ||
        document.getElementById('live-program-mobile');

    const scheduleList = document.querySelector('.hh-tv-schedule-list');

    if (liveProgram && scheduleList) {
        setTimeout(() => {
            const listRect = scheduleList.getBoundingClientRect();
            const programRect = liveProgram.getBoundingClientRect();

            scheduleList.scrollTo({
                top: programRect.top - listRect.top + scheduleList.scrollTop - 50,
                behavior: 'smooth'
            });
        }, 100);
    }
}